// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent }  from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAPMgDOdQAUvCWQScSiXgSlOmchJBmyprI",
  authDomain: "ecoforma-1955b.firebaseapp.com",
  projectId: "ecoforma-1955b",
  storageBucket: "ecoforma-1955b.appspot.com",
  messagingSenderId: "726975207841",
  appId: "1:726975207841:web:30aaff55883eab3ea3d3e0",
  measurementId: "G-8V7GHFR7V7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
